import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  id: "MassEditModal"
}
const _hoisted_2 = {
  key: 0,
  class: "MassEditModalContent"
}
const _hoisted_3 = { class: "MassEditModalSubtitle" }
const _hoisted_4 = { class: "MassEditSection" }
const _hoisted_5 = { class: "MassEditCheckboxLabel" }
const _hoisted_6 = ["id", "name", "checked", "onChange"]
const _hoisted_7 = {
  key: 0,
  class: "MassEditErrorMessage"
}
const _hoisted_8 = { class: "MassEditSection MassEditSectionButtons" }
const _hoisted_9 = {
  key: 1,
  class: "MassEditModalContent"
}
const _hoisted_10 = { class: "MassEditModalSubtitle" }
const _hoisted_11 = {
  ref: "massEditModifyBlock",
  class: "MassEditModifyBlock"
}
const _hoisted_12 = {
  key: 0,
  class: "MassEditSection"
}
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = {
  key: 0,
  class: "MassEditErrorMessage"
}
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = {
  key: 0,
  class: "MassEditErrorMessage"
}
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = {
  key: 0,
  class: "MassEditErrorMessage"
}
const _hoisted_19 = { class: "MassEditSection MassEditSectionButtons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "MassEditModalHeaderBlock" }, [
      _createElementVNode("h3", { class: "MassEditModalHeaderTitle" }, " Enrolment details ")
    ], -1 /* CACHED */)),
    (_ctx.modalStatusIsPropertySelection)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, " Which fields would you like to edit for " + _toDisplayString(_ctx.grammaticalNumberTextPresenter.theseAmountOfEnrolmentsDisplayText) + "? ", 1 /* TEXT */),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.massEditableKeys, (property) => {
              return (_openBlock(), _createElementBlock("label", _hoisted_5, [
                _createElementVNode("input", {
                  class: "MassEditCheckbox",
                  type: "checkbox",
                  id: property,
                  name: property,
                  checked: _ctx.massEditablePropertiesCluster[property].relevant,
                  onChange: ($event: any) => (_ctx.toggleMassEditableProperty(property))
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6),
                _createTextVNode(" " + _toDisplayString(_ctx.massEditablePropertiesCluster[property].label), 1 /* TEXT */)
              ]))
            }), 256 /* UNKEYED_FRAGMENT */)),
            (_ctx.showMassEditSelectionMessage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Select at least one property from the list to continue. "))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "DriverButton MassEditButton",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startModifyingSelectedProperties && _ctx.startModifyingSelectedProperties(...args)))
            }, " Continue ")
          ])
        ]))
      : (_ctx.modalStatusIsPropertyModification)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("h4", _hoisted_10, " Modifying " + _toDisplayString(_ctx.grammaticalNumberTextPresenter.amountOfEnrolmentsDisplayText), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relevantMassEditProperties, (property) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (_ctx.shouldPropertyBeAvailableForModification(property.key))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (property.key === _ctx.massEditableKeyTuitionFeeCurrency)
                          ? (_openBlock(), _createBlock(_component_MultiSelect, {
                              key: 0,
                              ref_for: true,
                              ref: "currencyDropdown",
                              label: _ctx.isCurrencyDropdownActive ? '' : property.label,
                              placeholder: property.label,
                              options: _ctx.currenciesAsOptions,
                              searchable: true,
                              entity: "currency",
                              valid: property.valid,
                              validationLabel: property.invalidMessage,
                              onUpdated: _ctx.selectCurrency
                            }, null, 8 /* PROPS */, ["label", "placeholder", "options", "valid", "validationLabel", "onUpdated"]))
                          : (property.key === _ctx.massEditableKeyTuitionFee)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("input", {
                                  class: "MassEditInput",
                                  type: "number",
                                  min: "0",
                                  placeholder: property.label,
                                  onInput: _cache[1] || (_cache[1] = (event) => _ctx.setTuitionFeeBasedOnEvent(event as unknown as { target: { value: number | null } }))
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_13),
                                (!property.valid)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(property.invalidMessage), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true),
                        (property.key === _ctx.massEditableKeyIntakeMonth)
                          ? (_openBlock(), _createBlock(_component_MultiSelect, {
                              key: 2,
                              ref_for: true,
                              ref: "monthDropdown",
                              label: _ctx.isMonthDropdownActive ? '' : property.label,
                              placeholder: property.label,
                              options: _ctx.monthsAsOptions,
                              searchable: true,
                              entity: "month",
                              valid: property.valid,
                              validationLabel: property.invalidMessage,
                              onUpdated: _ctx.selectMonth
                            }, null, 8 /* PROPS */, ["label", "placeholder", "options", "valid", "validationLabel", "onUpdated"]))
                          : (property.key === _ctx.massEditableKeyIntakeYear)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createElementVNode("input", {
                                  ref_for: true,
                                  ref: "intakeYearInput",
                                  class: "MassEditInput",
                                  type: "number",
                                  min: "0",
                                  placeholder: property.label,
                                  onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectIntakeYear && _ctx.selectIntakeYear(...args)))
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_15),
                                (!property.valid)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(property.invalidMessage), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true),
                        (property.key === _ctx.massEditableKeyStudentNationality)
                          ? (_openBlock(), _createBlock(_component_MultiSelect, {
                              key: 4,
                              ref_for: true,
                              ref: "nationalityDropdown",
                              label: _ctx.isNationalityDropdownActive ? '' : property.label,
                              placeholder: property.label,
                              options: _ctx.countriesAsOptions,
                              searchable: true,
                              entity: "country",
                              valid: property.valid,
                              validationLabel: property.invalidMessage,
                              onUpdated: _ctx.selectNationality
                            }, null, 8 /* PROPS */, ["label", "placeholder", "options", "valid", "validationLabel", "onUpdated"]))
                          : _createCommentVNode("v-if", true),
                        (property.key === _ctx.massEditableKeyCountryOfResidence)
                          ? (_openBlock(), _createBlock(_component_MultiSelect, {
                              key: 5,
                              ref_for: true,
                              ref: "residenceDropdown",
                              label: _ctx.isResidenceDropdownActive ? '' : property.label,
                              placeholder: property.label,
                              options: _ctx.countriesAsOptions,
                              searchable: true,
                              entity: "country",
                              valid: property.valid,
                              validationLabel: property.invalidMessage,
                              onUpdated: _ctx.selectResidence
                            }, null, 8 /* PROPS */, ["label", "placeholder", "options", "valid", "validationLabel", "onUpdated"]))
                          : (property.key === _ctx.massEditableKeyProgrammeName)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                _createElementVNode("input", {
                                  ref_for: true,
                                  ref: "programmeNameInput",
                                  class: "MassEditInput",
                                  type: "text",
                                  placeholder: property.label,
                                  onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selectProgrammeName && _ctx.selectProgrammeName(...args)))
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_17),
                                (!property.valid)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(property.invalidMessage), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true),
                        (property.key === _ctx.massEditableKeyProgrammeLevel)
                          ? (_openBlock(), _createBlock(_component_MultiSelect, {
                              key: 7,
                              ref_for: true,
                              ref: "programmeLevelDropdown",
                              label: _ctx.isProgrammeLevelDropdownActive ? '' : property.label,
                              placeholder: property.label,
                              options: _ctx.programmeLevelsAsOptions,
                              searchable: true,
                              entity: "programme level",
                              valid: property.valid,
                              validationLabel: property.invalidMessage,
                              onUpdated: _ctx.selectProgrammeLevel
                            }, null, 8 /* PROPS */, ["label", "placeholder", "options", "valid", "validationLabel", "onUpdated"]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "MassEditSection WarningContainer" }, [
              _createElementVNode("i", { class: "lnr-info WarningIcon" }),
              _createElementVNode("div", { class: "WarningMessage" }, [
                _createTextVNode(" Please note that, if you proceed, fields that are filled in here will "),
                _createElementVNode("strong", null, "overwrite existing details of all selected enrolments"),
                _createTextVNode(". ")
              ])
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_19, [
              (_ctx.isInternal)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "MassEditButton MassEditButtonBack",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goBackToPropertySelection && _ctx.goBackToPropertySelection(...args)))
                  }, " Back "))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                class: "DriverButton MassEditButton",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.saveSpecifiedValues && _ctx.saveSpecifiedValues(...args)))
              }, " Continue ")
            ])
          ]))
        : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}